module.exports = "/assets/data/822924eb95dd341c512c6a0db21c549e-WN6.data.json";